import { Box, IconButton, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import Panel from "./Panel";

const AddressbookPanelShell = ({
  title,
  titleContent,
  headerActions,
  footerLeft,
  footerRight,
  onClose,
  children,
}) => (
  <Panel
    title={title}
    titleContent={titleContent}
    headerActions={
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        {headerActions}
        {onClose && (
          <IconButton size="small" onClick={onClose} aria-label="Close panel">
            <CloseIcon sx={{ fontSize: 16 }} />
          </IconButton>
        )}
      </Box>
    }
    footer={
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, width: "100%" }}>
        <Box sx={{ minWidth: 0 }}>
          {typeof footerLeft === "string" ? (
            <Typography sx={{ color: "text.secondary", fontSize: 11 }}>{footerLeft}</Typography>
          ) : (
            footerLeft
          )}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>{footerRight}</Box>
      </Box>
    }
  >
    {children}
  </Panel>
);

export default AddressbookPanelShell;
